import { Component, OnInit, Input, ViewChild, TemplateRef } from '@angular/core';
import { DataTableDirective } from 'angular-datatables';
import { DataTablesResponse } from '../../shared/models/datatables-response';
import { HttpClient } from '@angular/common/http';
import { environment } from '../../../environments/environment'
import { ExchangeList } from '../../shared/models/ExchangeListOutputModel';
import { AuthenticationService } from '../../shared/auth/authentication.service';
import { ValidationService } from '../../shared/providers/validation.service';
import { BsModalService, BsModalRef } from 'ngx-bootstrap/modal';
import { BreadCrumbInput } from '../../shared/models/BreadCrumbInputModel';
import { Router, ActivatedRoute, Params } from '@angular/router';
enum tabs {
  ConnectedExchange = 1,
  MyExchange = 2
}

@Component({
  selector: 'app-exchange-1031-list',
  templateUrl: './exchange-1031-list.component.html'
})
export class Exchange1031ListComponent implements OnInit {
  @Input() PrincipalId: number = 0;
  constructor(private http: HttpClient, private Authentication: AuthenticationService, private Validation: ValidationService, private modalService: BsModalService, private router: Router) { }
  dtOptions = {};
  dtOptionConnected = {};
  table: DataTableDirective;
  @ViewChild(DataTableDirective) dtElement: DataTableDirective;
  @Input() breadCrumbInput: BreadCrumbInput = null;
  @Input() currentTab: string = null;
  BreadCrumb = {} as BreadCrumbInput;
  exchangeList: ExchangeList[];
  exchangesConnected: ExchangeList[];
  LoggedInUser: any;
  Tabs = tabs;
  protected readonly BASE_URL: string = environment.base_url;
  tableColums = [];
  activeTab = tabs.MyExchange;
  modalRef: BsModalRef;
  modalRefInvite: BsModalRef;
  ngOnInit() {
    if (this.breadCrumbInput) {
      this.BreadCrumb.PrevPageName = this.breadCrumbInput.PrevPageName;
      this.BreadCrumb.PrevPageLink = this.breadCrumbInput.PrevPageLink;
      if (this.currentTab !== null && this.currentTab !== undefined) {
        this.BreadCrumb.PrevPageLink += "?tab=" + this.currentTab;
      }
    }

    this.LoggedInUser = this.Authentication.user;
    if (this.Authentication.IsUserRole(this.Authentication.UserRole.Principal1031)) {
      this.PrincipalId = this.LoggedInUser.Id;
    }

    this.bindMyExchangeList();
  }

  IsLoading = false;
  bindMyExchangeList() {

    if (this.activeTab === tabs.MyExchange) {
      this.tableColums = [{ data: 'ExchangeID' },
      { data: 'ExchangeID' },
      { data: 'Connections' },
      { data: 'PrimaryBroker' },
      { data: 'StartDate' },
      { data: 'EndDate' },
      { data: 'LOIInProgress' },
      { data: 'DealsInProgress' }
      ]
    }
    else if (this.activeTab === tabs.ConnectedExchange) {
      this.tableColums = [
        { data: 'ExchangeID' },
        { data: 'PrincipalName' },
        { data: 'PrimaryBroker' },
        { data: 'StartDate' },
        { data: 'EndDate' },
        { data: 'LOIInProgress' },
        { data: 'DealsInProgress' }
      ]
    }

    const that = this;

    this.dtOptions = {
      pagingType: 'full_numbers',
      serverSide: true,
      processing: true,
      info: false,
      "pageLength": 50,
      language: {
        zeroRecords: null,
        processing: `<div class="custom-dt-loader">
        <div class="circle-loader-wrapper">
          <div class="circle-loader-ring"></div>
          <img src="assets/img/logos/logo.png" class="loader-icon" />
        </div>
      </div>
     `,
      },
      "order": [[1, "desc"]],
      bLengthChange: false,
      initComplete: () => $('.dataTables_filter').css('display', 'none'),
      ajax: (dataTablesParameters: any, callback: Function) => {
        const filter =
        {
          UserId: this.PrincipalId,
          Type: this.activeTab,
          LoggedInUserId: this.LoggedInUser.Id
        }
        dataTablesParameters.Extra_param = filter;
        this.IsLoading = true;
        const httpHeader = this.Validation.GetAuthHeader();
        that.http
          .post<DataTablesResponse>(
            this.BASE_URL + '/user1031/GetExchange1031List/',
            dataTablesParameters, httpHeader
          ).subscribe(resp => {
            that.exchangeList = resp.data ? resp.data : [];
            if (resp) {
              callback({
                recordsTotal: resp.recordsTotal,
                recordsFiltered: resp.recordsFiltered,
                data: []
              });
              if (resp.data.length === 0) {
                $(".dataTables_paginate.paging_full_numbers").hide();
              }
              else {
                $(".dataTables_paginate.paging_full_numbers").show();
              }
              $(".paginate_button.first,.paginate_button.last").hide();
            }
            else {
              callback({
                recordsTotal: 0,
                recordsFiltered: 0,
                data: []
              });
              $(".dataTables_paginate.paging_full_numbers").hide();
            }
            this.IsLoading = false;
          });
      },
      columns: this.tableColums
    };
  }
  reload(status) {
    this.dtElement.dtInstance.then(x => x.draw());
  }
  onSelect(tab): void {
    this.activeTab = tab;
    this.dtElement.dtInstance.then(x => x.draw());
  }

  onSearch(text: string) {
    this.dtElement.dtInstance.then(x => x.search(text).draw());
  }
  exchangeSelected = 0;
  openInviteeModal(template: TemplateRef<any>, classes, exchangeSelected) {
    this.exchangeSelected = exchangeSelected;
    this.modalRefInvite = this.modalService.show(template, { class: classes });
  }

  onInviteClose(status: boolean) {
    //this.router.navigateByUrl("redirect?url=" + encodeURIComponent(this.router.url), { skipLocationChange: true });
  }
}

